module.exports = __webpack_public_path__ + "img/streaming_rabbit_clouds.d9d079d7.svg";